<template>
<v-container fluid class="monitorSite stats-boxX elevation-2X px-4 fade-in">
<v-layout class="page-body pt-6 admin-page bg-light-blue">
      <v-flex xs12>
          <h1>Add New Offices with New Agencies</h1>
          <v-layout data-app wrap row>
            <v-flex xs12 class="horiz-margin-20">
              <!--Model popup window to add Office-->
              <div>
                <b-modal size="xl"  ref="my-modal" hide-footer v-model="addorupdateflag" :title="headingtitle" :no-close-on-backdrop="true" :no-close-on-esc="true">
                  <div>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <b-container fluid>
                        <b-row class="mb-1">
                          <b-col cols="3">Survey Type <span style="color:red">*</span></b-col>
                          <b-col>
                            <select v-model="addOffice.selectSurveyType" class="form-control" required :rules="surveyTypeRule" :disabled="disableFlag">
                              <option value="" selected>Select</option>
                              <option v-for="surveyType in surveyTypes" :value="surveyType.id" :key="surveyType.id">{{ surveyType.name }}</option>
                            </select>
                          </b-col>
                          <b-col cols="3">Agency <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOffice.agency" maxlength=6 label="Agency" required :rules="agencyRule" :disabled="disableFlag" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" style="width:150px"></v-text-field>
														eg.900000
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">Department Type <span style="color:red">*</span></b-col>
                          <b-col>
                            <select v-model="addOffice.selectDeptType" class="form-control" @change="onChangeDepartmentType($event)" required :rules="deptTypeRule" :disabled="disableFlag">
                              <option value="" selected>Select</option>
                              <option v-for="deptType in departmentTypes" :value="deptType.id" :key="deptType.id">{{ deptType.name }}</option>
                            </select>
                          </b-col>
                          <b-col cols="3">Department <span style="color:red">*</span></b-col>
                          <b-col>
                            <select v-model="addOffice.selectDeptment" class="form-control" required :rules="deptRule" :disabled="disableFlag">
                              <option value="" selected>Select</option>
                              <option v-for="deptment in departments" :value="deptment.departmentId" :key="deptment.departmentId">{{ deptment.departmentName }}</option>
                            </select>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">Office Name <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOffice.officeName" label="Office Name" required :rules="officeNameRule"></v-text-field>
                          </b-col>
                          <b-col cols="3">Office Abbreviation <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOffice.officeAbbreviation" label="Office Abbreviation" required :rules="officeAbbreviationRule"></v-text-field>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="3">Description</b-col>
                          <b-col>
                            <textarea v-model="addOffice.description" rows="5" cols="60" placeholder="Enter text" class="form-control" name="description" :min-height="200"
														:max-height="400"></textarea>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">First Name <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOffice.firstName" label="First Name" required :rules="firstNameRule" :disabled="disableFlag"></v-text-field>
                          </b-col>
                          <b-col cols="3">Last Name <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOffice.lastName" label="Last Name" required :rules="lastNameRule" :disabled="disableFlag"></v-text-field>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">E-mail <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOffice.emailId" label="E-mail" required :rules="emailRule" :disabled="disableFlag"></v-text-field>
                          </b-col>
                          <b-col cols="3">Title</b-col>
                          <b-col>
                            <input v-model="addOffice.title" type="text" class="form-control" id="title" name ="title" :disabled="disableFlag"/>
                          </b-col>
                        </b-row>
                         <b-row class="mb-1">
                          <b-col cols="3">Supervisor First Name</b-col>
                          <b-col>
                            <input v-model="addOffice.supervisorfirstName" type="text" class="form-control" id="supervisorfirstName" name="supervisorfirstName" :disabled="disableFlag"/>
                          </b-col>
                          <b-col cols="3">Supervisor Last Name</b-col>
                          <b-col>
                            <input v-model="addOffice.supervisorlastName" type="text" class="form-control" id="supervisorlastName" name ="supervisorlastName":disabled="disableFlag"/>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">Supervisor E-mail</b-col>
                          <b-col>
                            <input v-model="addOffice.supervisoremailId" type="text" class="form-control" id="supervisoremailId" name="supervisoremailId" :disabled="disableFlag"/>
                          </b-col>
                          <b-col cols="3">Supervisor Title</b-col>
                          <b-col>
                            <input v-model="addOffice.supervisorTitle" type="text" class="form-control" id="supervisorTitle" name ="supervisorTitle" :disabled="disableFlag"/>
                            <input v-model="addOffice.userId" type="hidden" id="userId"/>
                          </b-col>
                        </b-row>
                      </b-container>
                      <b-button class="form-button" :loading="isLoading" v-model="headingtitle" block @click="onSaveOffice(headingtitle)">Save</b-button>&nbsp;<span style="color:blue;">{{message}}</span>
                    </v-form>
                   </div>
                </b-modal>
              </div>
            </v-flex>
          </v-layout>

          <h2>Offices or Agencies Available to Select for This Year's Survey</h2>
          <v-flex xs12 class="horiz-margin-20">
            <v-data-table
              v-model="officeSelection"
              :headers="officeSelectionHeaders"
              :items="offices"
              :single-select="false"
              item-key="nameFirst"
              show-select
              class="elevation-1">
            <template #item.officeName={value} >
              <a href="#" @click="onAddNewOffice(value,false);">{{value}}</a>
            </template>
            </v-data-table>
          </v-flex>

          <v-layout data-app wrap row>
            <v-flex xs12 class="horiz-margin-20">
              <div class="buttons">&nbsp;<span style="color:blue;">{{officeMessage}}</span>
                <v-btn normal  :loading="isLoading" class="form-button"  @click="onAddSelectedOffices" :disabled="disablemakeOfficeinUseFlag || !officeSelection || officeSelection.length === 0"
                >Make Office(s) Avaiable</v-btn>&nbsp;
                <v-btn normal class="form-button" @click="onAddNewOffice(officename,true)">Add New Office</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
// @ is an alias to /src
import { authTokenService } from '@/services/authTokenService.js';
import { CONSTANTS } from '@/common/constants.js';
import router from '@/router';
import { reportingUnitsService } from "@/services/reportingUnitsService.js";
import { officeManagementService } from '@/services/officeManagementService.js';
import { authService } from "@/services/authService.js";
import { surveyService } from "@/services/surveyService.js";

export default {
	name: 'ReportingUnits',
	data: () => ({
        singleSelect: true,
        officeSelection: [],
        officeSelectionHeaders: [
          { text: 'Open Office Survey', value: 'userName', class: 'cellclname' },
          { text: 'Office Name (Click name to edit office contact information)', value: 'officeName' },
          { text: 'Office Abbrev', value: 'officeAbbreviation' },
          { text: 'Primary Contact', value: 'nameFirst' },
          { text: 'Primary E-mail Address', value: 'email' },
        ],
        offices: [],
        participatingOfficesList:[],
        section: null,
		    columns: null,
		    columnHeader: null,
        departmentTypes:[
          { name: "Department", id: 1 },
          { name: "Independent Agency", id: 2 }
        ],
        surveyTypes:[
          { name: "Non-DOD/Standard", id: 1 },
          { name: "DOD", id: 2 }
        ],
        selectedDepartmentType: null,
        departments:[],
        //Validtion rules
        emailRule: [
            v => !!v || "E-mail is required",
            v => /.+@.+/.test(v) || "E-mail must be valid"
        ],
        officeNameRule:[v => !!v || 'Office Name is required'],
        officeAbbreviationRule:[v => !!v || 'Office Abbreviation is required',
        v => (v && v.length <= 21) || 'Office Abbreviation must be less than 20 characters'],
        firstNameRule:[v => !!v || 'First Name is required'],
        lastNameRule:[v => !!v || 'Last Name is required'],
        deptTypeRule: [v => !!v || 'Department Type is required'],
        deptRule: [v => !!v || 'Department is required'],
        agencyRule:[v => !!v || 'Agency is required'],
        surveyTypeRule: [v => !!v || 'Survey Type is required'],
        message: '',
        //Variables
        addOffice:{
          agency:null,
          officeName:null,
          officeAbbreviation:null,
          description:null,
          firstName:null,
          lastName:null,
          emailId:null,
          title:null,
          supervisorfirstName:null,
          supervisorlastName:null,
          supervisoremailId:null,
          supervisorTitle:null,
          selectDeptType:null,
          selectDeptment:null,
          departmentId: null,
          userId: null,
          selectSurveyType:null,
          addnewFlag:null,
        },
        headingtitle:null,
        addorupdateflag:null,
        officeMessage:null,
        disableFlag:null,
        disablemakeOfficeinUseFlag:null,
        surveyRootId:null,
	}),
	methods: {
        onChangeDepartmentType (event) {
          const me=this;
          me.selectedDepartmentType = event.target.options[event.target.options.selectedIndex].text;
          var departType=0;
          me.departments=[];
          if(me.selectedDepartmentType=="Department")
            {departType=1}
          else
            {departType=2};
          officeManagementService.getAllDepartments(departType).then(function (response){
            if (response && response.data) {
              for(var i=0;i<response.data.length;i++)
              {
                me.departments.push(response.data[i]);
              }
            }
          });
        },
        onAddNewOffice (officename, flag) {
          debugger;
          const me=this;
          me.addorupdateflag=flag;
          if(officename!=null && !flag)
          {
              me.headingtitle="Update Offices";
							me.message='';
              surveyService.getOfficeInfo(officename).then(function(response){
              if (response && response.data)
              {
                  me.disableFlag=true;
                  me.addOffice.agency = response.data.agency;
                  me.addOffice.officeName=response.data.officeName;
                  me.addOffice.officeAbbreviation=response.data.officeAbbreviation;
                  me.addOffice.description=response.data.description;
                  me.addOffice.firstName=response.data.nameFirst;
                  me.addOffice.lastName=response.data.nameLast;
                  me.addOffice.emailId=response.data.email;
                  me.addOffice.title=response.data.title;
                  me.addOffice.supervisorfirstName=response.data.supNameFirst;
                  me.addOffice.supervisorlastName=response.data.supNameLast;
                  me.addOffice.supervisoremailId=response.data.supEmail;
                  me.addOffice.supervisorTitle=response.data.supTitle;
                  me.addOffice.userId = response.data.userId;
                  for(var i=0; me.surveyTypes.length>0; i++)
                  {
                     if(response.data.surveyType == me.surveyTypes[i].id)
                     {
                        me.addOffice.selectSurveyType = me.surveyTypes[i].id;
                        break;
                     }
                  }
                  for(var i=0; me.departmentTypes.length>0; i++)
                  {
                     if(response.data.departmentTypeId == me.departmentTypes[i].id)
                     {
                        me.addOffice.selectDeptType = me.departmentTypes[i].id;
                        break;
                     }
                  }
                  me.addOffice.departmentId=response.data.departmentId;
                  me.departments=[];
                  officeManagementService.getAllDepartments(me.addOffice.selectDeptType).then(function (res){
                    if (res && res.data) {
                      for(var i=0;i<res.data.length;i++)
                      {
                        me.departments.push(res.data[i]);
                      }

                      if(me.departments.length>0)
                      {
                        for(var j=0; j<=me.departments.length; j++)
                        {
                          if(me.departments[j].departmentId == me.addOffice.departmentId)
                          {
                              me.addOffice.selectDeptment = me.departments[j].departmentId;
                              break;
                          }
                        }
                      }

                    }
                });
              }
            });
          }
          else
          {
            me.disableFlag=false;
            me.addOffice.officeName=null;
            me.addOffice.officeAbbreviation=null;
            me.addOffice.description=null;
            me.addOffice.firstName=null;
            me.addOffice.lastName=null;
            me.addOffice.emailId=null;
            me.addOffice.title=null;
            me.addOffice.supervisorfirstName=null;
            me.addOffice.supervisorlastName=null;
            me.addOffice.supervisoremailId=null;
            me.addOffice.supervisorTitle=null;
            me.addOffice.selectDeptType="";
            me.addOffice.selectSurveyType="";
            me.addOffice.selectDeptment=null;
            me.addOffice.departmentId=null;
            me.addOffice.userId=null;
            me.headingtitle="Add New Offices with New Agencies";
          }
        	me.$refs['my-modal'].show();
			},
      onSaveOffice(headingtitle) {
        debugger;
        const me=this;
        me.message="Processing please wait..";
        if(me.headingtitle=="Add New Offices with New Agencies")
            me.addOffice.addnewFlag=true;
         else
            me.addOffice.addnewFlag=false;

        if (me.$refs.form.validate())
        {
          const claims = authTokenService.getClaims();
          me.isLoading = true;
          surveyService.saveNewAgencyWithNewOffice(me.addOffice.selectSurveyType, me.addOffice.agency, claims.surveyId, me.addOffice.selectDeptment, me.addOffice.officeName, me.addOffice.officeAbbreviation, me.addOffice.description,
            me.addOffice.firstName, me.addOffice.lastName, me.addOffice.emailId, me.addOffice.title, me.addOffice.supervisorfirstName, me.addOffice.supervisorlastName, me.addOffice.supervisoremailId, me.addOffice.supervisorTitle, me.addOffice.addnewFlag)
              .then(function(response)
              {
                  console.log(response);
                  if(response.data=="Successfully saved")
                  {
                    me.isLoading = false;
                    me.message=response.data;
                    me.offices=[];
                    setTimeout(() => {  me.OnLoad(); }, 2000);
                  }
                  else
                  {
                    me.isLoading = false;
                    me.message=response.data;
                  }
              })
              .catch(function(response) {
                console.log("me.addOffice.selectDeptType", me.addOffice.selectDeptType);
                console.log("me.addOffice.selectDeptment", me.addOffice.selectDeptment);
                if(me.addOffice.selectDeptType == "")
                  me.message= "Please select Department Type";
                else if(me.addOffice.selectDeptment == null)
                  me.message = "Please select Department name";
                else
                  me.message="Error occured or please verify the required fields or office name may exists";
                me.isLoading = false;
              });
       }
    },
    OnLoad(){
      const me = this;
      //getAllOffices which are Available
      me.officeMessage="Processing please wait..";
      me.offices=[];
      me.officeSelection=[];
      officeManagementService.getAvaiableOffices().then(function (response)
      {
        if (response && response.data)
        {
          for(var i=0;i<response.data.length;i++)
          {
            me.offices.push(response.data[i]);
          }
          me.officeMessage=null;
        }
      });
    },
    onAddSelectedOffices()
    {
        const me = this;
        me.disablemakeOfficeinUseFlag = true;
        me.officeMessage="Processing please wait..";
        me.$data.isLoading = true;
        me.participatingOfficesList=[];
        for(var i=0; i<me.officeSelection.length; i++)
        {
           me.participatingOfficesList.push(me.officeSelection[i].userName);
        }
        surveyService.makeUseOfAvaiableOffice(me.participatingOfficesList).then(function(response) {
             if (response && response.data) {
               me.disablemakeOfficeinUseFlag = false;
                setTimeout(() => {  me.OnLoad(); }, 2000);
                me.$data.isLoading = false;
                me.officeMessage=response.data;
                me.officeMessage="Sending emails please wait..";
                for(var i=0; i<me.officeSelection.length; i++)
                {
                    authService.emailSelectedOffices(me.officeSelection[i].email, me.officeSelection[i].userName,74).then(function(response) {
                        me.$data.isLoading = false;
                        me.$data.emailed = true;
                        me.$data.error = false;
                        me.officeMessage =  "E-mail sent to the selected offices";
                      })
                      .catch(function(response) {
                        console.log("OnEmail Selected Offices handle error in component");
                        me.$data.isLoading = false;
                        me.$data.error = true;
                        me.$data.emailed = false;
                        me.officeMessage=  response.data;
                      });
                }
             }
            })
            .catch(function(response) {
              me.$data.isLoading = false;
              me.$data.error = true;
              me.officeMessage=response.data;
            });
        me.$data.isLoading = false;
    },
	},
	mounted () {
    this.OnLoad();
	}
};
</script>

<style scoped>
.survey-container {
  width: 100%;
  margin: 0 auto;
}

.buttons {
  width: 80%;
  margin: 20px auto;
  text-align: center;
}

</style>
